import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47fb8600"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-deletion" }
const _hoisted_2 = { class: "account-deletion__intro" }
const _hoisted_3 = { class: "eyebrow" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" This is the official account deletion page for ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(", provided by the developer ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "SUHWAN LIM", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_8 = {
  class: "account-deletion__section",
  "aria-labelledby": "deletion-details"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { id: "deletion-details" }, "What happens when your account is deleted", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, " Personal information and content associated with the account, including your profile and workout log data, are deleted. ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, " Personal information remaining in backup systems is deleted within 90 days and is used only for disaster recovery during that period. ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, " We may retain the minimum information required by applicable law, or needed for fraud prevention or dispute resolution, only for the required period. ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "notice" }, " Account deletion cannot be undone. Deleting your account does not automatically cancel an active Google Play or App Store subscription. Please cancel any active subscription in the relevant store first. ", -1))
const _hoisted_14 = {
  class: "account-deletion__section",
  "aria-labelledby": "deletion-request"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { id: "deletion-request" }, "Request account deletion", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " If you registered with an email address and password, enter them below to verify ownership and permanently delete your account. ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Account email", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Password", -1))
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "success",
  role: "status"
}
const _hoisted_21 = {
  key: 1,
  class: "error",
  role: "alert"
}
const _hoisted_22 = {
  class: "account-deletion__section",
  "aria-labelledby": "social-account"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { id: "social-account" }, "Social sign-in accounts and support", -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" If you signed in with Google, Apple, Kakao, or LINE, or cannot use the form above, email ")
const _hoisted_25 = ["href"]
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" For more information, read our ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Privacy Policy")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(". ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('navigation.navbar.appTitle')) + " · SUHWAN LIM", 1),
      _createElementVNode("h1", null, "Delete your " + _toDisplayString(_ctx.$t('navigation.navbar.appTitle')) + " account", 1),
      _createElementVNode("p", null, [
        _hoisted_4,
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('navigation.navbar.appTitle')), 1),
        _hoisted_5,
        _hoisted_6,
        _hoisted_7
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, " Your " + _toDisplayString(_ctx.$t('navigation.navbar.appTitle')) + " account is permanently deleted. ", 1),
        _hoisted_10,
        _hoisted_11,
        _hoisted_12
      ]),
      _hoisted_13
    ]),
    _createElementVNode("section", _hoisted_14, [
      _hoisted_15,
      _hoisted_16,
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitDeletionRequest && _ctx.submitDeletionRequest(...args)), ["prevent"]))
      }, [
        _hoisted_17,
        _withDirectives(_createElementVNode("input", {
          type: "email",
          id: "email",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
          autocomplete: "username",
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.email]
        ]),
        _hoisted_18,
        _withDirectives(_createElementVNode("input", {
          type: "password",
          id: "password",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
          autocomplete: "current-password",
          required: "",
          minlength: "6"
        }, null, 512), [
          [_vModelText, _ctx.password]
        ]),
        _createElementVNode("button", {
          type: "submit",
          disabled: _ctx.isSubmitting
        }, _toDisplayString(_ctx.isSubmitting ? 'Processing...' : 'Permanently delete my account'), 9, _hoisted_19)
      ], 32),
      (_ctx.successMessage)
        ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.successMessage), 1))
        : _createCommentVNode("", true),
      (_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.errorMessage), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", _hoisted_22, [
      _hoisted_23,
      _createElementVNode("p", null, [
        _hoisted_24,
        _createElementVNode("a", { href: _ctx.accountDeletionEmailHref }, " ai.trainer.helpdesk@gmail.com ", 8, _hoisted_25),
        _createTextVNode(" from the email address associated with your account. Include “" + _toDisplayString(_ctx.$t('navigation.navbar.appTitle')) + " account deletion request” in the subject. We may ask you to verify account ownership before processing the request. ", 1)
      ]),
      _createElementVNode("p", null, [
        _hoisted_26,
        _createVNode(_component_router_link, { to: "/privacy-policy" }, {
          default: _withCtx(() => [
            _hoisted_27
          ]),
          _: 1
        }),
        _hoisted_28
      ])
    ])
  ]))
}